import Controller from '@ember/controller';
import { service } from '@ember/service';

export default class ResourcesTeamsArchivedController extends Controller {
  @service store;
  get teams() {
    return this.store
      .peekAll('team')
      .filter((item) => !item.active)
      .slice();
  }
}
